import { makeStyles } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FontSizes } from '../../../../../../core/config/mainTheme';
import { BenchmarkView } from '../../../../../../generated/model/benchmarkView';

export interface Props {
  toggleValue: BenchmarkView.ConsolidationPreferenceEnum;
  onToggleChange: (consolidated: BenchmarkView.ConsolidationPreferenceEnum) => void;
}

const ConsolidationToggle: React.FC<Props> = ({ toggleValue, onToggleChange }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const handleChange = (event: any, toggleValue: BenchmarkView.ConsolidationPreferenceEnum) => {
    if (toggleValue !== null) {
      onToggleChange(toggleValue);
    }
  };

  return (
    <ToggleButtonGroup
      className={classes.container}
      size="small"
      value={toggleValue}
      onChange={handleChange}
      exclusive
    >
      <ToggleButton value={'CONSOLIDATED' as BenchmarkView.ConsolidationPreferenceEnum}>
        {t('companies:consolidation:consolidated')}
      </ToggleButton>
      <ToggleButton value={'UNCONSOLIDATED' as BenchmarkView.ConsolidationPreferenceEnum}>
        {t('companies:consolidation:unconsolidated')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(4),
    alignItems: 'center',
    '& p': {
      fontSize: FontSizes.size.normal,
      fontWeight: 'bold',
      color: theme.palette.text.secondary,
    },
    '& .MuiToggleButton-root': {
      textTransform: 'none',
      fontSize: FontSizes.size.normal,
      fontWeight: 'bold',
      backgroundColor: theme.palette.grey[300],
    },
    '& .MuiToggleButton-root.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
  },
}));
export default ConsolidationToggle;
